import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import { PageSettings } from '../../../config/page-settings';

function Sttplan(props) {
    const context = useContext(PageSettings)
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
        setIsReadMore(!isReadMore);
    };
    useEffect(() => {
        context.handleSetPageSidebar(false)
        context.handleSetPageHeader(false)
        context.handleSetPageContentFullWidth(true);
        return () => {
            context.handleSetPageSidebar(true)
            context.handleSetPageHeader(true)
            context.handleSetPageContentFullWidth(false);
        }
    }, [])

    return (
        <div id="page-container" class="fade page-sidebar-fixed page-header-fixed login-v1">
            <div className="container-fluid stttplan">
                <div>
                    <h1 className="signup-header">Sign up for STT</h1>
                    <h4 className="signup-subheader">Choose your plan and upgrade or Cancel any time</h4>
                </div>
                <div className="row justify-content-center m-t-40 mb-5">
                    <div className="col-xl-2 col-md-4 mb-3">
                        <div className="card text-center border-0 card-size shadow-add">
                            <div className="card-header bg-none">
                                Starter
                            </div>
                            <div className='px-2 offertext'>
                                <h4 className='text-success my-2'>FREE BUMPER BONUS</h4>
                                <p className='mb-0 '>Unlimited dynamic/editable simple QR codes</p>
                                <p className='mb-0 '>Unlimited Static simple QR codes</p>
                            </div>
                            <div className="card-body pb-0">
                                <div className="mb-3">
                                    <p>9.99 EU/month</p>
                                    <a href="./Freesignup" className="btn btn-sm btn-success shadow-add px-4 sign-button">Sign up</a>
                                </div>

                                <ul className="text-left ">
                                    <li>150 QR Codes</li>
                                    {/* <li>Back End office</li>
                                    <li>Scan analytics</li> */}
                                    <li>Number of monthly scans <b>1500</b></li>
                                    <li>Data upload/storage limit <b>250 MB</b></li>
                                    <li>Number of total accounts 1</li>
                                    <li>Email Support</li>
                                    <li>STT smart wallet</li>
                                    <li>Managing catagories</li>
                                    <li>Advanced Search</li>

                                </ul>
                            </div>

                            <div className="card-footer border-0 bg-none pt-0">
                                <a href="/Sttplandetail" className="btn btn-sm btn-primary shadow-add px-4">View details</a>
                            </div>
                        </div>

                    </div>
                    <div className="col-xl-2 col-md-4 mb-3">
                        <div className="card text-center border-0 card-size  shadow-add">
                            <div className="card-header bg-none">
                                Permium
                            </div>
                            <div className='px-2 offertext'>
                                <h4 className='text-success my-2'>FREE BUMPER BONUS</h4>
                                <p className='mb-0 '>Unlimited dynamic/editable simple QR codes</p>
                                <p className='mb-0 '>Unlimited Static simple QR codes</p>
                            </div>
                            <div className="card-body pb-0">
                                <div className="mb-3">
                                    <p>19.99 EU/month</p>
                                    <a href="./Freesignup" className="btn btn-sm btn-success shadow-add px-4 sign-button">Sign up</a>
                                </div>

                                <ul className="text-left p-l-40">
                                    <li>450 QR Codes</li>
                                    {/* <li>Back End office</li>
                                    <li>Scan analytics</li>
                                    <li>Customer Track</li> */}
                                    <li>Unlimited scans</li>
                                    <li>Data upload/storage limit <b>500 MB</b></li>
                                    <li>Number of total accounts 1</li>
                                    <li>Email Support</li>
                                    <li>STT smart wallet</li>
                                    <li>Managing catagories</li>
                                    <li>Advanced Search</li>
                                    <li>Product/Artilce QR code Chat</li>
                                    <li>Number of customers Chats 50</li>
                                    <li>Export QR codes data to Excell and CSV files</li>

                                </ul>

                            </div>

                            <div className="card-footer border-0 bg-none pt-0">
                                <button onClick={toggleReadMore} className="btn btn-sm btn-primary shadow-add px-4">View details</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-md-4 mb-3">
                        <div className="card text-center border-0 card-size shadow-add ">
                            <div className="card-header bg-none">
                                Basic
                            </div>
                            <div className='px-2 offertext'>
                                <h4 className='text-success my-2'>FREE BUMPER BONUS</h4>
                                <p className='mb-0 '>Unlimited dynamic/editable simple QR codes</p>
                                <p className='mb-0 '>Unlimited Static simple QR codes</p>
                            </div>
                            <div className="card-body pb-0">
                                <div className="mb-3">
                                    <p cla>99 EU /month</p>
                                    <a href="./Enterprisesign" className="btn btn-sm btn-success shadow-add px-4 sign-button">Sign up</a>
                                </div>
                                <ul className="text-left ">
                                    <li>2,500 QR Codes</li>
                                    {/* <li>24hrs Service</li>
                                    <li>Back End office</li>
                                    <li>Scan analytics</li>
                                    <li>Customer Track</li> */}
                                    <li>Unlimited scans</li>
                                    <li>Data upload/storage limit <b>2.5 GB</b></li>
                                    <li>Number of total accounts 2</li>
                                    <li>Email Support</li>
                                    <li>STT smart wallet</li>
                                    <li>Managing catagories</li>
                                    <li>Advanced Search</li>
                                    <li>Product/Artilce QR code Chat</li>
                                    <li>Number of customers Chats 250</li>
                                    <li>Export QR codes data to Excell and CSV files</li>
                                    <li>Export Scaning data to Excell and CSV files </li>
                                    <li>Daily analytics in Email </li>
                                </ul>
                            </div>

                            <div className="card-footer border-0 bg-none pt-0">
                                <a href="/Enterprisesign" className="btn btn-sm btn-primary shadow-add px-4">View details</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-md-4 mb-3">
                        <div className="card text-center border-0 card-size shadow-add ">
                            <div className="card-header bg-none">
                                Advance
                            </div>
                            <div className='px-2 offertext'>
                                <h4 className='text-success my-2'>FREE BUMPER BONUS</h4>
                                <p className='mb-0 '>Unlimited dynamic/editable simple QR codes</p>
                                <p className='mb-0 '>Unlimited Static simple QR codes</p>
                            </div>
                            <div className="card-body pb-0">
                                <div className="mb-3">
                                    <p>199 EU/month</p>
                                    <a href="./Enterprisesign" className="btn btn-sm btn-success shadow-add px-4 sign-button">Sign up</a>
                                </div>
                                <ul className="text-left ">
                                    <li>10,000 QR Codes</li>
                                    {/* <li>24hrs Service</li>
                                    <li>Back End office</li>
                                    <li>Scan analytics</li>
                                    <li>Customer Track</li> */}
                                    <li>Unlimited scans</li>
                                    <li>Data upload/storage limit <b>5GB</b></li>
                                    <li>Number of total accounts 5</li>
                                    <li>Email Support</li>
                                    <li>STT smart wallet</li>
                                    <li>Managing catagories</li>
                                    <li>Advanced Search</li>
                                    <li>Product/Artilce QR code Chat</li>
                                    <li>Unlimited customers Chats</li>
                                    <li>Export QR codes data to Excell and CSV files</li>
                                    <li>Export Scaning data to Excell and CSV files </li>
                                    <li>Daily analytics in Email </li>
                                    <li>Individual Phone support </li>
                                </ul>
                            </div>

                            <div className="card-footer border-0 bg-none pt-0">
                                <a href="/Enterprisesign" className="btn btn-sm btn-primary shadow-add px-4">View details</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-2 col-md-4 mb-3">
                        <div className="card text-center border-0 card-size shadow-add ">
                            <div className="card-header bg-none">
                                Cutomised
                            </div>
                            <div className='px-2 offertext'>
                                <h4 className='text-success my-2'>FREE BUMPER BONUS</h4>
                                <p className='mb-0 '>Unlimited dynamic/editable simple QR codes</p>
                                <p className='mb-0 '>Unlimited Static simple QR codes</p>
                            </div>
                            <div className="card-body pb-0">
                                <div className="mb-3">
                                    <p>
                                        <Link to='#' className="m-b-5">Pls contact</Link>
                                    </p>
                                    <a href="./Enterprisesign" className="btn btn-sm btn-success shadow-add px-4 sign-button">Sign up</a>
                                </div>
                                <ul className="text-left ">
                                    <li>Unlimited QR Codes</li>
                                    {/* <li>24hrs Service</li>
                                    <li>Back End office</li>
                                    <li>Scan analytics</li> */}
                                    <li>Unlimited scans</li>
                                    <li><li>Data upload/storage limit <Link to='#' className="m-b-5">Pls contact</Link></li></li>
                                    <li>Number of total accounts <Link to='#' className="m-b-5">Pls contact</Link></li>
                                    <li>Email Support</li>
                                    <li>STT smart wallet</li>
                                    <li>Managing catagories</li>
                                    <li>Advanced Search</li>
                                    <li>Product/Artilce QR code Chat</li>
                                    <li>Unlimited customers Chats</li>
                                    <li>Export QR codes data to Excell and CSV files</li>
                                    <li>Export Scaning data to Excell and CSV files </li>
                                    <li>Daily analytics in Email </li>
                                    <li>Individual Phone support </li>

                                </ul>
                            </div>

                            <div className="card-footer border-0 bg-none pt-0">
                                <a href="/Enterprisesign" className="btn btn-sm btn-primary shadow-add px-4">View details</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default Sttplan;